<template>
  <div>
    <el-tabs class="tab-button" v-model="activeTab">
      <el-tab-pane label="어플리케이션" name="application">
        <w-application-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="SQL" name="sql">
        <w-sql-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="API 호출" name="api">
        <w-api-call-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="IP" name="ip">
        <w-ip-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="유저 에이전트" name="agent">
        <w-user-agent-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="트랜잭션 예외" name="exception">
        <w-service-error-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="경보" name="alert">
        <w-alert-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <!-- <el-tab-pane label="NAV" name="nav">
        <w-nav-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="AJAX" name="ajax">
        <w-ajax-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane>
      <el-tab-pane label="JS Error" name="jserror">
        <w-js-error-table :activeTab="activeTab" :params="params"/>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from '@/utils/basic';
import { getIntervalDatetimeParams } from '@/utils/date';
import WApplicationTable from './components/table/ApplicationTable';
import WSqlTable from './components/table/SqlTable';
import WApiCallTable from './components/table/ApiCallTable';
import WIpTable from './components/table/IpTable';
import WUserAgentTable from './components/table/UserAgentTable';
import WServiceErrorTable from './components/table/ServiceErrorTable';
import WAlertTable from './components/table/AlertTable';
import WNavTable from './components/table/NavTable';
import WAjaxTable from './components/table/AjaxTable';
import WJsErrorTable from './components/table/JsErrorTable';

export default {
  name: 'WPerformanceInstanceAnalysisTable',
  components: {
    WApplicationTable,
    WSqlTable,
    WApiCallTable,
    WIpTable,
    WUserAgentTable,
    WServiceErrorTable,
    WAlertTable,
    WNavTable,
    WAjaxTable,
    WJsErrorTable,
  },
  props: {
    active: Boolean,
    operationFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 'application',
    };
  },
  computed: {
    params() {
      const selectedNode = this.selectedNode;
      const selectedAnalysisChartDate = this.selectedAnalysisChartDate;
      if (!this.active || isEmpty(selectedNode.obj) || isEmpty(selectedAnalysisChartDate)) {
        return null;
      } else if (this.active && !isEmpty(selectedNode.obj) && this.operationFlag) {
        // [운영 탭] 차트 데이터를 불러오지않아 고정 현재시간(-24) 계산
        return { objId: selectedNode.obj.objId, startDatetime: getIntervalDatetimeParams(new Date().getTime(), 'hour', 24), endDatetime: new Date().getTime() };
      }
      return {
        selectedObjectTypeText: 'obj',
        functionTypeText: 'analysis',
        selectedObjectId: selectedNode.obj.objId,
        objId: selectedNode.obj.objId,
        startDatetime: this.selectedAnalysisChartDate.startDatetime,
        endDatetime: this.selectedAnalysisChartDate.endDatetime,
      };
    },
    ...mapGetters(['selectedNode', 'analysisDateParams', 'selectedAnalysisChartDate']),
  },
  watch: {
    analysisDateParams: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.$store.dispatch('setSelectedAnalysisChartDate', null);
        }
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/apm/PerformanceInstanceAnalysisTable.vue